import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import { Button as WPButton } from "@wordpress/components";

const Button = ({ children, isSubmitting, disabled, ...props }) => {
	return (
		<WPButton {...props} disabled={isSubmitting || disabled}>
			<div className="flex items-center justify-between px-10">
				{isSubmitting && (
					<CircularProgress
						size={25}
						thickness={4}
						className="mr-5"
						color="inherit"
					/>
				)}
				{children}
			</div>
		</WPButton>
	);
};

Button.propTypes = {
	children: PropTypes.node,
	isSubmitting: PropTypes.bool,
	disabled: PropTypes.bool,
};
export default Button;
